import React from "react";
import Layout from "../components/organisms/layout/layout";
import LibraryComponents from "../components/templates/library-components/libraryComponents";
import { ReferenciaOrganismos } from "../interfaces/ReferenciaOrganismos";
import SEO from "../shared/seo";
import Disclaimer from "../components/molecules/disclaimer/disclaimer";
import RecentEditions from "../components/molecules/recent-editions/recentEditions";
import FeaturedEdition, {
  IFeaturedEdition,
} from "../components/molecules/featured-edition/featuredEdition";
import { dateToRelativeFormat } from "../utils/dateToRelativeFormat";
import { useStaticQuery, graphql } from "gatsby";

const TemplateEdicion = (props: any) => {
  const data = useStaticQuery(graphql`
    query categoriasYArticulos {
      allContentfulSubcategoria(
        filter: { tipoContenido: { eq: "Categoria" } }
      ) {
        nodes {
          nombreSubcategoria
          slug
          referenciaSubcategorias {
            nombreSubcategoria
            nroEdicion
            slug
            contentful_id
          }
        }
      }
    }
  `);
  
  const getParentSlug = (id) => {
    const result = data.allContentfulSubcategoria.nodes.filter((category) => {
      let articles = category.referenciaSubcategorias?.map(
        (subcat) => subcat.contentful_id
      );
      if (typeof articles === "undefined") return false;
      return articles.some((e) => e === id);
    });
    return result[0]?.slug;
  };

  const getParentCategory = (id) => {
    const result = data.allContentfulSubcategoria.nodes.filter((category) => {
      let articles = category.referenciaSubcategorias?.map(
        (subcat) => subcat.contentful_id
      );
      if (typeof articles === "undefined") return false;
      return articles.some((e) => e === id);
    });
    return result[0]?.nombreSubcategoria;
  };

  const pageData = props.pageContext;
  const keyName =
    pageData.referenciaCabecera && pageData.referenciaCabecera.tipoCabecera;
  const pageSlug = props.location.pathname;
  
  const adapterFeaturedEdition = (data: any) => {
    let process: IFeaturedEdition = {
      notas: data.map((nota: any) => ({
        tags: [getParentCategory(nota.contentful_id)],
        titulo: nota.nombreSubcategoria,
        description:
          nota.referenciaInterna.referenciaCabecera.descripcion.json.content[0].content[0].value.split(
            "."
          )[0] + ".",
        imageURL:
          nota.referenciaInterna.referenciaCabecera.imagenHeader.file.url,
        slug: "/" + getParentSlug(nota.contentful_id) + nota.slug,
        autor:
          nota.referenciaInterna.referenciaCabecera.referenciaAutor.nombreTab,
        fecha: dateToRelativeFormat(nota.createdAt),
        tiempo: `${Math.floor(Math.random() * 6) + 3} minutos`,
      })),
    };
    return process;
  };

  return (
    <Layout
      hideHeaderDesktop={false}
      hideHeaderMobile={false}
      isNotRoot={true}
      headboard={
        {
          ...pageData.referenciaCabecera,
          tipoCabecera: "CabeceraPaginaArticulos",
        } || {}
      }
      showPlayer={true}
    >
      <SEO
        title={props.pageContext.nombreCategoria || props.pageContext.referenciaCabecera.migaDePan.split("/")[2]}
        slug={pageSlug}
        description={
          pageData.metaDescripcion &&
          pageData.metaDescripcion.json.content[0].content[0].value
        }
        image={
          pageData.referenciaCabecera.imagenHeader &&
          pageData.referenciaCabecera.imagenHeader.file.url
        }
        lang="es"
      />
      {pageData.referenciaOrganismos &&
        pageData.referenciaOrganismos.map(
          (value: ReferenciaOrganismos, index: number) => (
            <div key={index} className={keyName} id={`${keyName}${index}`}>
              <LibraryComponents
                content={value}
                categoryName={pageData.nombreCategoria}
              />
            </div>
          )
        )}
      <RecentEditions
        className="agrupadora"
        editions={pageData.subcategorias.slice(0, 3).map((subcat) => ({
          tags: [getParentCategory(subcat.contentful_id)],
          title: subcat.nombreSubcategoria,
          description:
            subcat.referenciaInterna.referenciaCabecera.descripcion.json.content[0].content[0].value.split(
              "."
            )[0] + ".",
          imageURL:
            subcat.referenciaInterna.referenciaCabecera.imagenHeader.file.url,
          slug: "/" + getParentSlug(subcat.contentful_id) + subcat.slug,
          label: dateToRelativeFormat(subcat.createdAt),
          labelB: "3 minutos",
        }))}
      />
      <FeaturedEdition
        className="agrupadora"
        {...adapterFeaturedEdition(pageData.subcategorias.slice(3, 4))}
      />
      <RecentEditions
        className="agrupadora"
        editions={pageData.subcategorias.slice(4).map((subcat) => ({
          tags: [getParentCategory(subcat.contentful_id)],
          title: subcat.nombreSubcategoria,
          description:
            subcat.referenciaInterna.referenciaCabecera.descripcion.json.content[0].content[0].value.split(
              "."
            )[0] + ".",
          imageURL:
            subcat.referenciaInterna.referenciaCabecera.imagenHeader.file.url,
          slug: "/" + getParentSlug(subcat.contentful_id) + subcat.slug,
          label: dateToRelativeFormat(subcat.createdAt),
          labelB: "3 minutos",
        }))}
      />
      <Disclaimer />
    </Layout>
  );
};

export default TemplateEdicion;
